// extracted by mini-css-extract-plugin
export var cartContainer = "_ot-4";
export var gray = "_ot-1";
export var itemContainer = "_ot-2";
export var itemDetails = "_ot-3";
export var strong = "_ot-0";